import { TXCarouselTemplate } from "../../../types/common/templates.types";
import { X_CAROUSEL_TEMPLATE_1 } from "./template1";

export const X_CAROUSEL_TEMPLATES: TXCarouselTemplate = {
  ...X_CAROUSEL_TEMPLATE_1,
};
